import { FaArrowRight } from "react-icons/fa";
import BrocolyLink from "../../../../utils/BrocolyLink";
// import { useNavigateAndScroll } from "../../../../hooks/useNavigateAndScroll";

export const CustomerIntelligenceSection = () => {
  // const navigateAndScroll = useNavigateAndScroll();

  return (
    <section
      className="light-section"
      style={{ marginTop: "4rem" }}
      id="brocoly"
    >
      <img
        className="img-tableros"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_customer.png`}
        alt="tableros"
      />
      <div
        className="columna"
        style={{ marginInline: "auto", width: "fit-content", maxWidth: "55%" }}
      >
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Inteligencia del cliente</p>
        </span>
        <p className="section-title">
          <span>
            Impulse las ventas <br />
            y la satisfacción <br />
            del <span style={{ color: "var(--red-highlight)" }}> cliente</span>
          </span>
        </p>

        <p className="section-subtitle">
          integrá la inteligencia del cliente en tu estrategia de <br />
          marketing para mejorar la comunicación, aumentar <br />
          <span className="underscore">
            las ventas y hacer
            <img
              alt="subrayado"
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado2-21.png`}
            />
          </span>{" "}
          que tus clientes estén mas satisfechos
        </p>
        <span className="horizontal gap-16" style={{ marginTop: 50 }}>
          <BrocolyLink>
            <button className="boton-generico boton-blanco">
              <p>Conocé más de brocoly</p>
              <FaArrowRight />
            </button>
          </BrocolyLink>
        </span>
      </div>
    </section>
  );
};
